import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Collected from '@/views/Collected'
import Detail from '@/views/Detail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/Index',
      component: Index
    },
    {
      path: '/Collected',
      component: Collected
    },
    {
      path: '/Detail',
      component: Detail
    },
    {
      path: '*',
      redirect: {path: '/Index'}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js